import React from 'react';
import {
  Card, CardBody, Row, Col, CardHeader, Carousel, CarouselItem, CarouselControl, CarouselIndicators,
} from 'reactstrap';
import PropTypes from 'prop-types';
import './style.css';

export default function AccountProfileCarousel({
  account, activeHolder, next, previous, goToIndex, onExited, onExiting, redirectPerson, Link, avoidRedirection
}) {
  return (
    <Card style={{ height: 250 }}>
      <CardHeader style={{ textAlign: 'center' }}>
        {account.AccountIsPhysical ?
          (account.AccountInfoHolder[activeHolder].AccountHolderRelationship) : (
            account.AccountInfoHolder[activeHolder].AccountHolderRelationshipJuridical
          )}
        {account.AccountInfoHolder[activeHolder].IsMainHolder && ' (Main Holder)'}
      </CardHeader>
      <CardBody
        className="personCard"
      >
        <Carousel
          activeIndex={activeHolder}
          next={next}
          previous={previous}
          interval={false}
          style={{ height: '100%' }}
        >
          <CarouselIndicators
            items={account.AccountInfoHolder}
            activeIndex={activeHolder}
            onClickHandler={goToIndex}
          />
          {account.AccountInfoHolder && account.AccountInfoHolder.map((d) => (
            <CarouselItem
              onExiting={onExiting}
              onExited={onExited}
              key={d.AccountHolderId}
              style={{ paddingBottom: 5, height: '100%' }}
            >
              <h3 className="mt-0">
              {avoidRedirection ? (
                d.AccountHolderName
              ):(
                <Link
                  to={`/person/${d.AccountHolderId}`}
                  target="_blank"
                >
                  {d.AccountHolderName}
                </Link>
              )} 
              </h3>
              <ul className="list-unstyled mb-0">
                <li className="mb-1">
                  <em className="fas fa-map-marker-alt fa-fw" />
                  {d.AccountHolderCountryName}
                </li>
                <li className="mb-1">
                  <em className="fas fa-map-marker-alt fa-fw" />
                  <strong>{d.AccountHolderEmail}</strong>
                </li>
                <li className="mb-1">
                  <em className="fas fa-map-marker-alt fa-fw" />
                  {d.AccountHolderPersonType}
                </li>
                <li className="mb-1">
                  <em className="fas fa-map-marker-alt fa-fw" />
                  {d.AccountHolderDocumentTypeName}
                  {': '}
                  {d.AccountHolderDocumentNumber}
                </li>
              </ul>
            </CarouselItem>
          ))}
          <CarouselControl direction="prev" color="black" directionText="Previous" onClickHandler={previous} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
        </Carousel>
      </CardBody>
    </Card>
  );
}

AccountProfileCarousel.propTypes = {
  account: PropTypes.object.isRequired,
  activeHolder: PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  previous: PropTypes.func.isRequired,
  goToIndex: PropTypes.func.isRequired,
  onExited: PropTypes.func.isRequired,
  onExiting: PropTypes.func.isRequired,
  redirectPerson: PropTypes.func.isRequired,
};
